var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.50001 4.3C9.30671 4.3 9.15001 4.4567 9.15001 4.65V6.5H14.85V4.65C14.85 4.4567 14.6933 4.3 14.5 4.3H9.50001ZM16.15 6.5V4.65C16.15 3.73873 15.4113 3 14.5 3H9.50001C8.58874 3 7.85001 3.73873 7.85001 4.65V6.5H5.50735C5.50294 6.49996 5.49852 6.49996 5.49408 6.5H3.50001C3.14102 6.5 2.85001 6.79101 2.85001 7.15C2.85001 7.50899 3.14102 7.8 3.50001 7.8H4.89993L5.77846 18.7816C5.84706 19.6391 6.56296 20.3 7.4232 20.3H16.5768C17.4371 20.3 18.153 19.6391 18.2216 18.7816L19.1001 7.8H20.5C20.859 7.8 21.15 7.50899 21.15 7.15C21.15 6.79101 20.859 6.5 20.5 6.5H18.5059C18.5015 6.49996 18.4971 6.49996 18.4927 6.5H16.15ZM6.20408 7.8L7.07432 18.6779C7.08887 18.8598 7.24072 19 7.4232 19H16.5768C16.7593 19 16.9111 18.8598 16.9257 18.6779L17.7959 7.8H6.20408ZM10 10C10.359 10 10.65 10.291 10.65 10.65V16.15C10.65 16.509 10.359 16.8 10 16.8C9.64102 16.8 9.35001 16.509 9.35001 16.15V10.65C9.35001 10.291 9.64102 10 10 10ZM14 10C14.359 10 14.65 10.291 14.65 10.65V16.15C14.65 16.509 14.359 16.8 14 16.8C13.641 16.8 13.35 16.509 13.35 16.15V10.65C13.35 10.291 13.641 10 14 10Z",
    fill: "#565A5E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDelete);
export default __webpack_public_path__ + "static/media/ic-delete.97ad289389558c59b4f0dc10de7fe493.svg";
export { ForwardRef as ReactComponent };